import React, { FunctionComponent } from 'react';
import { PersonShowMainItem } from '../../molecules/personShowMainItem';
import { PreferredOccupationItem } from '../../../types/personShow';

type Props = {
  mainTitle: string;
  penIconImg: string;
  motivation: string;
  preferredLocations: string[];
  preferredOccupations: PreferredOccupationItem[];
  preferenceConditions: string[];
  handleClick: (target: string, title: string) => void;
  isShow: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  mainTitle,
  penIconImg,
  motivation,
  preferredLocations,
  preferredOccupations,
  preferenceConditions,
  handleClick,
  isShow,
}) => {
  const shouldDisplay = (value: any): boolean => {
    if (value === '' || value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
      return isShow;
    }
    return true;
  };

  return (
    <>
      <h2 className="mainTitle">{mainTitle}</h2>
      {shouldDisplay(motivation) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="モチベーション"
          value={motivation}
          type="normal"
          id="motivation"
          handleClick={handleClick}
          isShow={isShow}
          word="選択する"
          isMiddle
        />
      )}
      {shouldDisplay(preferredLocations) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="希望勤務地"
          array={preferredLocations}
          type="location"
          id="preferredLocations"
          handleClick={handleClick}
          isShow={isShow}
          word="選択する"
          isMiddle
        />
      )}
      {shouldDisplay(preferredOccupations) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="希望職種"
          array={preferredOccupations}
          type="occupations"
          id="preferredOccupations"
          handleClick={handleClick}
          isShow={isShow}
          word="選択する"
        />
      )}
      {shouldDisplay(preferenceConditions) && (
        <PersonShowMainItem
          penIconImg={penIconImg}
          title="こだわり条件"
          array={preferenceConditions}
          type="preferenceConditions"
          id="preferenceConditions"
          handleClick={handleClick}
          isShow={isShow}
          word="選択する"
        />
      )}
    </>
  );
};
